
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dwkNQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $lE63B = parcelRequire("lE63B");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $2Nwuj = parcelRequire("2Nwuj");


var $2Pg7f = parcelRequire("2Pg7f");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $iquRY = parcelRequire("iquRY");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");


var $1688F = parcelRequire("1688F");


var $1chEN = parcelRequire("1chEN");


var $3c7da = parcelRequire("3c7da");


var $86H8K = parcelRequire("86H8K");


var $308Wd = parcelRequire("308Wd");

const $a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation = (0, $lE63B.default);
const $a159289724029162$var$i18n = (0, $cgtv4.defineMessages)({
    headingSingleUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.single-user",
        defaultMessage: "Someone needs additional access"
    },
    headingMultiUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.multi-user",
        defaultMessage: "Some people need additional access"
    },
    parentAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    parentAccessRolesRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.roles-update.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access."
    },
    spaceAccessViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view and edit permissions only. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.roles-update.body",
        defaultMessage: "They need edit access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully edit <bold>{pageTitle}</bold>."
    },
    spaceAccessViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.roles-update.body",
        defaultMessage: "They need view access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>."
    },
    spaceAccessRoleSelectionForViewAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-view-access.body",
        defaultMessage: "<bold>Role</bold>"
    },
    spaceAccessRoleSelectionForEditAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-edit-access.body",
        defaultMessage: "<bold>Roles that allow editing</bold>"
    },
    skipButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.skip-button",
        defaultMessage: "Skip for now"
    },
    addToParentButton: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.add-to-parent-button",
        defaultMessage: "Add to parent"
    },
    addToSpaceButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.add-to-space-button",
        defaultMessage: "Add to space"
    },
    addToAllButton: {
        id: "share-and-restrict-dialog.resolve-restriction.add-to-all-button",
        defaultMessage: "Add to all"
    },
    multiUserSpaceViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with edit access at the space level only. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserSpaceViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserParentViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserParentViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. They\u2019ll be added to any parent items with view-only access."
    },
    multiUserViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs to be granted view access in other places first before they can successfully view <bold>{pageTitle}</bold>. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserViewSpaceIncludedRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.space-included.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    usersNameList: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.single-restriction.body",
        defaultMessage: "{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}"
    },
    errorFlagTitle: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.title",
        defaultMessage: "Can\u2019t add guests"
    },
    errorFlagBodyDescription: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.body",
        defaultMessage: "One or more guests can\u2019t be added to the space because they have access to another space already. Guests can only access one space at a time."
    }
});
const $a159289724029162$var$collaboratorSystemRoleId = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $a159289724029162$var$selectStyle = (0, $ecnYn.xcss)({
    width: '150px'
});
const $a159289724029162$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $a159289724029162$export$51715d98ed95f9db = (restrictedPrincipals = [])=>{
    const hasSpaceRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
    const hasParentRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType !== (0, $1chEN.ResourceType).SPACE));
    if (hasSpaceRestriction && hasParentRestriction) return 'space-and-parent';
    else if (hasSpaceRestriction) return 'space';
    else return 'parent';
};
const $a159289724029162$var$hasSpaceRestriction = (restrictedPrincipals = [])=>{
    return restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
};
const $a159289724029162$var$mapSpaceRoleToOption = (role)=>({
        id: role?.roleId || '',
        label: role?.roleName || '',
        value: role?.roleId || '',
        description: role?.roleDescription || ''
    });
const $a159289724029162$export$b8299340c4128c03 = (t0)=>{
    const $ = (0, $frIzR.c)(199);
    const { restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection, pageTitle: pageTitle, contentId: contentId, addMode: addMode, onComplete: onComplete, onClose: onClose, onCloseComplete: onCloseComplete, onSkip: onSkip, showErrorFlag: showErrorFlag, triggeredBy: triggeredBy } = t0;
    const intl = (0, $8C5kA.default)();
    const focusRef = (0, $42omo.useRef)(null);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== assignableSpaceRolesIntersection) {
        t1 = assignableSpaceRolesIntersection?.map($a159289724029162$var$mapSpaceRoleToOption) || [];
        $[0] = assignableSpaceRolesIntersection;
        $[1] = t1;
    } else t1 = $[1];
    const roleOptions = t1;
    let t2;
    if ($[2] !== roleOptions) {
        t2 = ()=>{
            const collaboratorRole = roleOptions.find($a159289724029162$var$_temp);
            if (collaboratorRole) return collaboratorRole;
            return roleOptions[0] || null;
        };
        $[2] = roleOptions;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedRole, setSelectedRole] = (0, $42omo.useState)(t2);
    let t3;
    if ($[4] !== onClose || $[5] !== onSkip) {
        t3 = ()=>{
            onSkip();
            onClose?.();
        };
        $[4] = onClose;
        $[5] = onSkip;
        $[6] = t3;
    } else t3 = $[6];
    const onCloseButtonClick = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const usersCount = restrictedUserPrincipals ? restrictedUserPrincipals.length : 0;
    let t4;
    let t5;
    if ($[7] !== createAnalyticsEvent || $[8] !== triggeredBy) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "ResolveRestrictionsDialog",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        t5 = [
            createAnalyticsEvent,
            triggeredBy
        ];
        $[7] = createAnalyticsEvent;
        $[8] = triggeredBy;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[11] !== restrictedUserPrincipals) {
        t6 = restrictedUserPrincipals?.map($a159289724029162$var$_temp2);
        $[11] = restrictedUserPrincipals;
        $[12] = t6;
    } else t6 = $[12];
    const blockedAccessSubjects = t6;
    let t7;
    if ($[13] !== contentType || $[14] !== createAnalyticsEvent || $[15] !== intl || $[16] !== onClose || $[17] !== onComplete || $[18] !== onSkip || $[19] !== restrictedUserPrincipals || $[20] !== showErrorFlag || $[21] !== triggeredBy || $[22] !== usersCount) {
        t7 = (data)=>{
            if (data?.resolveRestrictionsForSubjects?.success) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "success",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                onComplete();
                onClose?.();
            } else {
                const errors = data?.resolveRestrictionsForSubjects?.errors;
                const isGuestError = errors?.some($a159289724029162$var$_temp3);
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "failure",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            errors: errors,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                if (isGuestError) {
                    showErrorFlag({
                        title: intl.formatMessage($a159289724029162$var$i18n.errorFlagTitle),
                        description: intl.formatMessage($a159289724029162$var$i18n.errorFlagBodyDescription),
                        isAutoDismiss: true
                    });
                    onSkip(isGuestError);
                    onClose?.();
                }
            }
        };
        $[13] = contentType;
        $[14] = createAnalyticsEvent;
        $[15] = intl;
        $[16] = onClose;
        $[17] = onComplete;
        $[18] = onSkip;
        $[19] = restrictedUserPrincipals;
        $[20] = showErrorFlag;
        $[21] = triggeredBy;
        $[22] = usersCount;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== createAnalyticsEvent || $[25] !== triggeredBy) {
        t8 = (error_0)=>{
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "errored",
                    actionSubject: "resolveRestrictionsForSubjects",
                    attributes: {
                        message: error_0?.message,
                        name: error_0?.name,
                        stack: error_0?.stack,
                        cause: error_0?.cause,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            setIsLoading(false);
        };
        $[24] = createAnalyticsEvent;
        $[25] = triggeredBy;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
        t9 = {
            onCompleted: t7,
            onError: t8
        };
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    const [resolveRestrictionsForSubjectsMutation] = (0, $308Wd.useMutationInterop)($a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation, t9);
    let t10;
    if ($[30] !== addMode || $[31] !== blockedAccessSubjects || $[32] !== contentId || $[33] !== contentType || $[34] !== createAnalyticsEvent || $[35] !== resolveRestrictionsForSubjectsMutation || $[36] !== restrictedUserPrincipals || $[37] !== selectedRole?.value || $[38] !== triggeredBy || $[39] !== usersCount) {
        t10 = ()=>{
            setIsLoading(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "AddResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            resolveRestrictionsForSubjectsMutation({
                variables: {
                    contentId: contentId,
                    accessType: addMode == "as-editor" ? (0, $1688F.ResourceAccessType).EDIT : (0, $1688F.ResourceAccessType).VIEW,
                    subjects: blockedAccessSubjects || [],
                    spaceRoleId: selectedRole?.value || null
                }
            });
        };
        $[30] = addMode;
        $[31] = blockedAccessSubjects;
        $[32] = contentId;
        $[33] = contentType;
        $[34] = createAnalyticsEvent;
        $[35] = resolveRestrictionsForSubjectsMutation;
        $[36] = restrictedUserPrincipals;
        $[37] = selectedRole?.value;
        $[38] = triggeredBy;
        $[39] = usersCount;
        $[40] = t10;
    } else t10 = $[40];
    const handleAdd = t10;
    let t11;
    if ($[41] !== contentType || $[42] !== createAnalyticsEvent || $[43] !== onClose || $[44] !== onSkip || $[45] !== restrictedUserPrincipals || $[46] !== triggeredBy || $[47] !== usersCount) {
        t11 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "SkipResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            onSkip();
            onClose?.();
        };
        $[41] = contentType;
        $[42] = createAnalyticsEvent;
        $[43] = onClose;
        $[44] = onSkip;
        $[45] = restrictedUserPrincipals;
        $[46] = triggeredBy;
        $[47] = usersCount;
        $[48] = t11;
    } else t11 = $[48];
    const handleSkip = t11;
    if (usersCount < 1) return null;
    const isSingleUserAndSingleRestriction = restrictedUserPrincipals?.length == 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1;
    const firstRestriction = restrictedUserPrincipals && restrictedUserPrincipals?.length > 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1 && restrictedUserPrincipals[0].restrictedResources[0];
    const isMultiUserSingleRestriction = !isSingleUserAndSingleRestriction && restrictedUserPrincipals?.every((obj)=>{
        if (obj?.restrictedResources?.length == 1) {
            if (firstRestriction && obj?.restrictedResources[0]?.resourceId == firstRestriction?.resourceId) return true;
        }
        return false;
    });
    let t12;
    if ($[49] !== addMode || $[50] !== isRbacEnabled || $[51] !== restrictedUserPrincipals || $[52] !== roleOptions || $[53] !== selectedRole) {
        t12 = ()=>{
            if (!isRbacEnabled || !$a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals)) return null;
            const roleSelectionBody = addMode === "as-viewer" ? $a159289724029162$var$i18n.spaceAccessRoleSelectionForViewAccessBody : $a159289724029162$var$i18n.spaceAccessRoleSelectionForEditAccessBody;
            const SELECT_STYLE_PROPS = {
                isSearchable: false,
                menuPortalTarget: document.body,
                styles: {
                    menu: $a159289724029162$var$_temp4,
                    menuPortal: $a159289724029162$var$_temp5
                }
            };
            const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a159289724029162$var$_temp6);
            const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($a159289724029162$var$_temp7);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text",
                testId: "selectRoleText"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                values: {
                    bold: $a159289724029162$var$_temp8
                },
                ...roleSelectionBody
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $a159289724029162$var$selectStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
                options: roleOptions,
                value: selectedRole,
                onChange: (option)=>setSelectedRole(option),
                components: {
                    SingleValue: CustomSingleValue,
                    Option: CustomOption
                },
                ...SELECT_STYLE_PROPS
            })));
        };
        $[49] = addMode;
        $[50] = isRbacEnabled;
        $[51] = restrictedUserPrincipals;
        $[52] = roleOptions;
        $[53] = selectedRole;
        $[54] = t12;
    } else t12 = $[54];
    const renderSpaceRoleSelector = t12;
    if (isSingleUserAndSingleRestriction) {
        const singleUserPrincipal = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal;
        const singleRestrictedResource = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].restrictedResources && restrictedUserPrincipals[0].restrictedResources[0];
        const t13 = singleRestrictedResource && singleRestrictedResource.resourceLink.base || "";
        const t14 = singleRestrictedResource && singleRestrictedResource.resourceLink.webUi || "";
        let resourceUrl;
        if ($[55] !== t13 || $[56] !== t14) {
            resourceUrl = t13 + t14;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl)) {
                resourceUrl = resourceUrl + "?referrer=share-and-restrict-dialog";
                resourceUrl;
            }
            $[55] = t13;
            $[56] = t14;
            $[57] = resourceUrl;
        } else resourceUrl = $[57];
        const resourceTitle = singleRestrictedResource && singleRestrictedResource.resourceTitle;
        const spaceAccessViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const parentAccessBody = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const editorMessage = addMode === "as-editor" ? spaceAccessViewAndEdit : spaceAccessView;
        const singleUserBodyMessageId = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? editorMessage : parentAccessBody;
        let t15;
        if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingSingleUser));
            $[58] = t15;
        } else t15 = $[58];
        let t16;
        if ($[59] !== onCloseButtonClick) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t15, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[59] = onCloseButtonClick;
            $[60] = t16;
        } else t16 = $[60];
        const t17 = singleUserPrincipal && singleUserPrincipal.avatarUrl;
        let t18;
        if ($[61] !== t17) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: t17
            });
            $[61] = t17;
            $[62] = t18;
        } else t18 = $[62];
        const t19 = singleUserPrincipal && singleUserPrincipal.name;
        let t20;
        if ($[63] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text"
            }, t19);
            $[63] = t19;
            $[64] = t20;
        } else t20 = $[64];
        let t21;
        if ($[65] !== t18 || $[66] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.150",
                alignBlock: "center"
            }, t18, t20);
            $[65] = t18;
            $[66] = t20;
            $[67] = t21;
        } else t21 = $[67];
        let t22;
        if ($[68] !== resourceUrl) {
            t22 = (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: resourceUrl
                }, chunks_0);
            $[68] = resourceUrl;
            $[69] = t22;
        } else t22 = $[69];
        let t23;
        if ($[70] !== pageTitle || $[71] !== resourceTitle || $[72] !== t22) {
            t23 = {
                pageTitle: pageTitle,
                resourceTitle: resourceTitle,
                resourceLink: t22,
                bold: $a159289724029162$var$_temp9,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[70] = pageTitle;
            $[71] = resourceTitle;
            $[72] = t22;
            $[73] = t23;
        } else t23 = $[73];
        let t24;
        if ($[74] !== singleUserBodyMessageId || $[75] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                values: t23,
                ...singleUserBodyMessageId
            });
            $[74] = singleUserBodyMessageId;
            $[75] = t23;
            $[76] = t24;
        } else t24 = $[76];
        let t25;
        if ($[77] !== renderSpaceRoleSelector) {
            t25 = renderSpaceRoleSelector();
            $[77] = renderSpaceRoleSelector;
            $[78] = t25;
        } else t25 = $[78];
        let t26;
        if ($[79] !== t21 || $[80] !== t24 || $[81] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t21, t24, t25));
            $[79] = t21;
            $[80] = t24;
            $[81] = t25;
            $[82] = t26;
        } else t26 = $[82];
        let t27;
        if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton);
            $[83] = t27;
        } else t27 = $[83];
        let t28;
        if ($[84] !== handleSkip || $[85] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t27);
            $[84] = handleSkip;
            $[85] = isLoading;
            $[86] = t28;
        } else t28 = $[86];
        const t29 = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t30;
        if ($[87] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), t29);
            $[87] = t29;
            $[88] = t30;
        } else t30 = $[88];
        let t31;
        if ($[89] !== handleAdd || $[90] !== isLoading || $[91] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t30);
            $[89] = handleAdd;
            $[90] = isLoading;
            $[91] = t30;
            $[92] = t31;
        } else t31 = $[92];
        let t32;
        if ($[93] !== t28 || $[94] !== t31) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t28, t31);
            $[93] = t28;
            $[94] = t31;
            $[95] = t32;
        } else t32 = $[95];
        let t33;
        if ($[96] !== Modal || $[97] !== onClose || $[98] !== onCloseComplete || $[99] !== t16 || $[100] !== t26 || $[101] !== t32) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete,
                testId: "modal-dialog-resolve-restrictions"
            }, t16, t26, t32);
            $[96] = Modal;
            $[97] = onClose;
            $[98] = onCloseComplete;
            $[99] = t16;
            $[100] = t26;
            $[101] = t32;
            $[102] = t33;
        } else t33 = $[102];
        return t33;
    } else if (isMultiUserSingleRestriction) {
        let t13;
        if ($[103] !== restrictedUserPrincipals) {
            t13 = restrictedUserPrincipals ? restrictedUserPrincipals.map($a159289724029162$var$_temp0) : [];
            $[103] = restrictedUserPrincipals;
            $[104] = t13;
        } else t13 = $[104];
        const avatarGroupData = t13;
        const t14 = firstRestriction && firstRestriction.resourceLink.base || "";
        const t15 = firstRestriction && firstRestriction.resourceLink.webUi || "";
        let resourceUrl_0;
        if ($[105] !== t14 || $[106] !== t15) {
            resourceUrl_0 = t14 + t15;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl_0)) {
                resourceUrl_0 = resourceUrl_0 + "?referrer=share-and-restrict-dialog";
                resourceUrl_0;
            }
            $[105] = t14;
            $[106] = t15;
            $[107] = resourceUrl_0;
        } else resourceUrl_0 = $[107];
        const spaceAccessViewAndEdit_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const i18nSpaceAccess = addMode === "as-editor" ? spaceAccessViewAndEdit_0 : spaceAccessView_0;
        const parentAccessBody_0 = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const multiUserSingleRestrictionBodyMessageId = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? i18nSpaceAccess : parentAccessBody_0;
        let t16;
        if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingMultiUser));
            $[108] = t16;
        } else t16 = $[108];
        let t17;
        if ($[109] !== onCloseButtonClick) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[109] = onCloseButtonClick;
            $[110] = t17;
        } else t17 = $[110];
        let t18;
        if ($[111] !== avatarGroupData) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                data: avatarGroupData,
                maxCount: 4
            });
            $[111] = avatarGroupData;
            $[112] = t18;
        } else t18 = $[112];
        const t19 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t20 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t21 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t22 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t23 = usersCount - 3;
        let t24;
        if ($[113] !== t19 || $[114] !== t20 || $[115] !== t21 || $[116] !== t22 || $[117] !== t23 || $[118] !== usersCount) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$a159289724029162$var$i18n.usersNameList,
                values: {
                    usersCount: usersCount,
                    firstUser: t19,
                    secondUser: t20,
                    thirdUser: t21,
                    fourthUser: t22,
                    remainingUserCount: t23
                }
            }));
            $[113] = t19;
            $[114] = t20;
            $[115] = t21;
            $[116] = t22;
            $[117] = t23;
            $[118] = usersCount;
            $[119] = t24;
        } else t24 = $[119];
        let t25;
        if ($[120] !== t18 || $[121] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "center"
            }, t18, t24);
            $[120] = t18;
            $[121] = t24;
            $[122] = t25;
        } else t25 = $[122];
        const t26 = firstRestriction && firstRestriction.resourceTitle;
        let t27;
        if ($[123] !== resourceUrl_0) {
            t27 = (chunks_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: resourceUrl_0
                }, chunks_2);
            $[123] = resourceUrl_0;
            $[124] = t27;
        } else t27 = $[124];
        let t28;
        if ($[125] !== pageTitle || $[126] !== t26 || $[127] !== t27) {
            t28 = {
                pageTitle: pageTitle,
                resourceTitle: t26,
                resourceLink: t27,
                bold: $a159289724029162$var$_temp1,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[125] = pageTitle;
            $[126] = t26;
            $[127] = t27;
            $[128] = t28;
        } else t28 = $[128];
        let t29;
        if ($[129] !== multiUserSingleRestrictionBodyMessageId || $[130] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                values: t28,
                ...multiUserSingleRestrictionBodyMessageId
            });
            $[129] = multiUserSingleRestrictionBodyMessageId;
            $[130] = t28;
            $[131] = t29;
        } else t29 = $[131];
        let t30;
        if ($[132] !== renderSpaceRoleSelector) {
            t30 = renderSpaceRoleSelector();
            $[132] = renderSpaceRoleSelector;
            $[133] = t30;
        } else t30 = $[133];
        let t31;
        if ($[134] !== t25 || $[135] !== t29 || $[136] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t25, t29, t30));
            $[134] = t25;
            $[135] = t29;
            $[136] = t30;
            $[137] = t31;
        } else t31 = $[137];
        let t32;
        if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton);
            $[138] = t32;
        } else t32 = $[138];
        let t33;
        if ($[139] !== handleSkip || $[140] !== isLoading) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t32);
            $[139] = handleSkip;
            $[140] = isLoading;
            $[141] = t33;
        } else t33 = $[141];
        const t34 = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t35;
        if ($[142] !== t34) {
            t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), t34);
            $[142] = t34;
            $[143] = t35;
        } else t35 = $[143];
        let t36;
        if ($[144] !== handleAdd || $[145] !== isLoading || $[146] !== t35) {
            t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t35);
            $[144] = handleAdd;
            $[145] = isLoading;
            $[146] = t35;
            $[147] = t36;
        } else t36 = $[147];
        let t37;
        if ($[148] !== t33 || $[149] !== t36) {
            t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t33, t36);
            $[148] = t33;
            $[149] = t36;
            $[150] = t37;
        } else t37 = $[150];
        let t38;
        if ($[151] !== Modal || $[152] !== onClose || $[153] !== onCloseComplete || $[154] !== t17 || $[155] !== t31 || $[156] !== t37) {
            t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t17, t31, t37);
            $[151] = Modal;
            $[152] = onClose;
            $[153] = onCloseComplete;
            $[154] = t17;
            $[155] = t31;
            $[156] = t37;
            $[157] = t38;
        } else t38 = $[157];
        return t38;
    } else {
        const hasSpaceRestricted = $a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals);
        const multiUserSpaceViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.multiUserSpaceViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserSpaceViewAndEditBody;
        const multiUserParentViewAndEditBody = isRbacEnabled ? $a159289724029162$var$i18n.multiUserParentViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserParentViewAndEditBody;
        const multiUserViewAndEditI18n = hasSpaceRestricted ? multiUserSpaceViewAndEdit : multiUserParentViewAndEditBody;
        const multiUserViewRolesUpdateBody = hasSpaceRestricted ? $a159289724029162$var$i18n.multiUserViewSpaceIncludedRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewRolesUpdateBody;
        const multiUserViewBody = isRbacEnabled ? multiUserViewRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewBody;
        const multiUsersBodyMessageId = addMode === "as-editor" ? multiUserViewAndEditI18n : multiUserViewBody;
        const isSingleUser = restrictedUserPrincipals?.length === 1;
        const modalHeight = isSingleUser ? "inherit" : "600px";
        let t13;
        if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingSingleUser));
            $[158] = t13;
        } else t13 = $[158];
        let t14;
        if ($[159] !== onCloseButtonClick) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[159] = onCloseButtonClick;
            $[160] = t14;
        } else t14 = $[160];
        const t15 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t16 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t17 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t18 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t19 = usersCount - 3;
        let t20;
        if ($[161] !== pageTitle || $[162] !== t15 || $[163] !== t16 || $[164] !== t17 || $[165] !== t18 || $[166] !== t19 || $[167] !== usersCount) {
            t20 = {
                usersCount: usersCount,
                firstUser: t15,
                secondUser: t16,
                thirdUser: t17,
                fourthUser: t18,
                remainingUserCount: t19,
                pageTitle: pageTitle,
                bold: $a159289724029162$var$_temp10,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[161] = pageTitle;
            $[162] = t15;
            $[163] = t16;
            $[164] = t17;
            $[165] = t18;
            $[166] = t19;
            $[167] = usersCount;
            $[168] = t20;
        } else t20 = $[168];
        let t21;
        if ($[169] !== multiUsersBodyMessageId || $[170] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.100",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...multiUsersBodyMessageId,
                values: t20
            })));
            $[169] = multiUsersBodyMessageId;
            $[170] = t20;
            $[171] = t21;
        } else t21 = $[171];
        let t22;
        if ($[172] !== renderSpaceRoleSelector) {
            t22 = renderSpaceRoleSelector();
            $[172] = renderSpaceRoleSelector;
            $[173] = t22;
        } else t22 = $[173];
        let t23;
        if ($[174] !== restrictedUserPrincipals) {
            t23 = restrictedUserPrincipals && restrictedUserPrincipals.map($a159289724029162$var$_temp11);
            $[174] = restrictedUserPrincipals;
            $[175] = t23;
        } else t23 = $[175];
        let t24;
        if ($[176] !== t21 || $[177] !== t22 || $[178] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.200"
            }, t21, t22, t23));
            $[176] = t21;
            $[177] = t22;
            $[178] = t23;
            $[179] = t24;
        } else t24 = $[179];
        let t25;
        if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton);
            $[180] = t25;
        } else t25 = $[180];
        let t26;
        if ($[181] !== handleSkip || $[182] !== isLoading) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t25);
            $[181] = handleSkip;
            $[182] = isLoading;
            $[183] = t26;
        } else t26 = $[183];
        let t27;
        if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.addToAllButton);
            $[184] = t27;
        } else t27 = $[184];
        let t28;
        if ($[185] !== handleAdd || $[186] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t27);
            $[185] = handleAdd;
            $[186] = isLoading;
            $[187] = t28;
        } else t28 = $[187];
        let t29;
        if ($[188] !== t26 || $[189] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, t26, t28);
            $[188] = t26;
            $[189] = t28;
            $[190] = t29;
        } else t29 = $[190];
        let t30;
        if ($[191] !== Modal || $[192] !== modalHeight || $[193] !== onClose || $[194] !== onCloseComplete || $[195] !== t14 || $[196] !== t24 || $[197] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
                width: "500px",
                height: modalHeight,
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t14, t24, t29);
            $[191] = Modal;
            $[192] = modalHeight;
            $[193] = onClose;
            $[194] = onCloseComplete;
            $[195] = t14;
            $[196] = t24;
            $[197] = t29;
            $[198] = t30;
        } else t30 = $[198];
        return t30;
    }
};
function $a159289724029162$var$_temp(role) {
    return role.id === $a159289724029162$var$collaboratorSystemRoleId;
}
function $a159289724029162$var$_temp2(user) {
    const blockedAccessSubject = {
        subjectId: user?.userPrincipal?.id || "",
        subjectType: (0, $1688F.BlockedAccessSubjectType).USER
    };
    return blockedAccessSubject;
}
function $a159289724029162$var$_temp3(error) {
    return error.message === "ExcoSingleSpaceException: Failed to save permission for guest: guest already has access to another space";
}
function $a159289724029162$var$_temp4(base) {
    return {
        ...base,
        width: "320px"
    };
}
function $a159289724029162$var$_temp5(base_0) {
    return {
        ...base_0,
        zIndex: 600
    };
}
function $a159289724029162$var$_temp6(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label);
}
function $a159289724029162$var$_temp7(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props_0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a159289724029162$var$menuItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props_0.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest"
    }, props_0.data.description)));
}
function $a159289724029162$var$_temp8(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks);
}
function $a159289724029162$var$_temp9(chunks_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_1);
}
function $a159289724029162$var$_temp0(user_0) {
    return {
        key: user_0?.userPrincipal?.email || "",
        name: user_0?.userPrincipal?.name || "",
        href: "#",
        src: user_0?.userPrincipal?.avatarUrl || ""
    };
}
function $a159289724029162$var$_temp1(chunks_3) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks_3);
}
function $a159289724029162$var$_temp10(chunk) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, chunk);
}
function $a159289724029162$var$_temp11(user_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050",
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
        role: "presentation",
        style: {
            width: "100%"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3c7da.RestrictedUserResourcesDetails), {
        user: user_1.userPrincipal,
        restrictedResources: user_1.restrictedResources
    })));
}
module.exports["getBlockedResourceTypes"] = $a159289724029162$export$51715d98ed95f9db;
module.exports["ResolveRestrictionsDialog"] = $a159289724029162$export$b8299340c4128c03;

});

parcelRegister("lE63B", function(module, exports) {
/**
 * @generated SignedSource<<505e42f52f069544fc19be9ae47af09b>>
 * @relayHash 4a516532f481795a6fb98a0e01c981b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898
const $94aa94c1917f6c40$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "4a516532f481795a6fb98a0e01c981b9",
            "id": "3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898",
            "metadata": {},
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$94aa94c1917f6c40$var$node.hash = "ff5bb2cdac9b46578fa9fdfee10454ed";
var $94aa94c1917f6c40$export$2e2bcd8739ae039 = $94aa94c1917f6c40$var$node;
module.exports["default"] = $94aa94c1917f6c40$export$2e2bcd8739ae039;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $49cfd043cf935c3d$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$49cfd043cf935c3d$var$getOverrides(overrides).MoreIndicator.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$49cfd043cf935c3d$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $6MWy1 = parcelRequire("6MWy1");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $1ztii = parcelRequire("1ztii");

const $5d9c84f5f87b7a1d$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($5d9c84f5f87b7a1d$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["FocusManagerContext"] = $5d9c84f5f87b7a1d$export$f18c1d4fc7326096;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $6MWy1 = parcelRequire("6MWy1");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _1q8w1np6 _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _t9ec1np6 _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("1688F", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $1565541f45629689$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $1565541f45629689$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
module.exports["BlockedAccessSubjectType"] = $1565541f45629689$export$43eb1e191ddb78c0;
module.exports["ResourceAccessType"] = $1565541f45629689$export$8e7b7bb509dc942b;

});

parcelRegister("1chEN", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $597ccb3a2cb4013d$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $597ccb3a2cb4013d$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
var $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["DATABASE"] = "DATABASE";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["PAGE"] = "PAGE";
    ResourceType["SPACE"] = "SPACE";
    ResourceType["WHITEBOARD"] = "WHITEBOARD";
    return ResourceType;
}({});
var $597ccb3a2cb4013d$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ResourceType"] = $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb;

});

parcelRegister("3c7da", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $esRft = parcelRequire("esRft");


var $9Q2dU = parcelRequire("9Q2dU");


var $5tmwS = parcelRequire("5tmwS");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $8jHAi = parcelRequire("8jHAi");


var $cO1el = parcelRequire("cO1el");


var $iKskQ = parcelRequire("iKskQ");

const $c3b447d238ca71b0$var$i18n = (0, $cgtv4.defineMessages)({
    needsAccess: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.needs-access",
        defaultMessage: "needs access in {resourcesCount} {resourcesCount, plural, one {place} other {places}}:"
    },
    space: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.space",
        defaultMessage: "Space"
    },
    parentItems: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.parent-items",
        defaultMessage: "Parent items"
    }
});
const $c3b447d238ca71b0$var$getContenTypeIcon = (type)=>{
    switch(type){
        case 'DATABASE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "Databse"
            });
        case 'WHITEBOARD':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "Whiteboard"
            });
        case 'PAGE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: "Page"
            });
        case 'FOLDER':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                label: "Page"
            });
        case 'SPACE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                size: "xsmall",
                src: "/images/logo/default-space-logo-256.png"
            });
    }
};
const $c3b447d238ca71b0$var$SingleResourcesDetails = (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { restrictedResource: restrictedResource, showLock: showLock } = t0;
    let t1;
    if ($[0] !== showLock) {
        t1 = showLock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }) : null;
        $[0] = showLock;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== restrictedResource) {
        t2 = restrictedResource && $c3b447d238ca71b0$var$getContenTypeIcon(restrictedResource.resourceType);
        $[2] = restrictedResource;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = restrictedResource ? restrictedResource.resourceTitle : "";
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, t1, t2, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $c3b447d238ca71b0$export$c6de5a3e56b68494 = (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { user: user, restrictedResources: restrictedResources } = t0;
    let t1;
    if ($[0] !== restrictedResources) {
        t1 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp);
        $[0] = restrictedResources;
        $[1] = t1;
    } else t1 = $[1];
    const resourcesWithoutSpace = t1;
    let t2;
    if ($[2] !== restrictedResources) {
        t2 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp2);
        $[2] = restrictedResources;
        $[3] = t2;
    } else t2 = $[3];
    const restrictedSpaces = t2;
    const resourcesWithoutSpaceCount = resourcesWithoutSpace ? resourcesWithoutSpace.length : 0;
    const restrictedSpacesCount = restrictedSpaces ? restrictedSpaces.length : 0;
    const resourcesCount = resourcesWithoutSpaceCount + restrictedSpacesCount;
    const t3 = user && user.avatarUrl;
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: t3
        });
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = user && user.name;
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text",
            weight: "bold"
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== resourcesCount) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: {
                resourcesCount: resourcesCount
            },
            ...$c3b447d238ca71b0$var$i18n.needsAccess
        });
        $[8] = resourcesCount;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center"
        }, t4, t6, t7);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== restrictedSpaces) {
        t9 = restrictedSpaces && restrictedSpaces.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c3b447d238ca71b0$var$i18n.space)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.150"
        }, restrictedSpaces.map($c3b447d238ca71b0$var$_temp3))) : null;
        $[14] = restrictedSpaces;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== resourcesWithoutSpace) {
        t10 = resourcesWithoutSpace && resourcesWithoutSpace.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c3b447d238ca71b0$var$i18n.parentItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, resourcesWithoutSpace.map($c3b447d238ca71b0$var$_temp4)))) : null;
        $[16] = resourcesWithoutSpace;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.200",
            alignBlock: "center"
        }, t9, t10));
        $[18] = t10;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, t8, t11);
        $[21] = t11;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    return t12;
};
function $c3b447d238ca71b0$var$_temp(resource) {
    if (resource?.resourceType === "SPACE") return false;
    return true;
}
function $c3b447d238ca71b0$var$_temp2(resource_0) {
    if (resource_0?.resourceType === "SPACE") return true;
    return false;
}
function $c3b447d238ca71b0$var$_temp3(resource_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_1,
        showLock: false,
        key: resource_1?.resourceId
    });
}
function $c3b447d238ca71b0$var$_temp4(resource_2) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_2,
        showLock: true,
        key: resource_2?.resourceId
    });
}
module.exports["RestrictedUserResourcesDetails"] = $c3b447d238ca71b0$export$c6de5a3e56b68494;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("86H8K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $fdPUP = parcelRequire("fdPUP");

const $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';
const $09f2383e12028cd7$export$40b60b643290317e = (chunks)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'blockedAccessLearnMore'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION,
        onClick: handleClick
    }, chunks);
};
module.exports["LearnMoreChunk"] = $09f2383e12028cd7$export$40b60b643290317e;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dh538.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ResolveRestrictionsDialog.65d3296b.js.map
